module.exports = __webpack_public_path__ + "img/code-light.438280fc.svg";